<template>
	<v-dialog
		v-model="localValue"
		transition="dialog-transition"
		width="400"
		ref="dialog"
		content-class="rounded-medium">
		<template v-slot:default="dialog">
			<v-card class="rounded-medium">
				<form @submit.prevent="">
					<v-card-title primary-title class="pb-0">
						{{ $t('confirm-delete') }}
						<v-spacer />
						<v-btn
							@click="localValue = false"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pb-0">
						<!-- dialog content -->
						<v-container fluid>
							<!-- default slot -->
							<slot></slot>
						</v-container>
					</v-card-text>
					<v-card-actions class="align-center">
						<v-spacer></v-spacer>
						<v-btn
							:loading="loading"
							@click="deleteData"
							color="error"
							dark>
							{{ $t('delete') }}
						</v-btn>
						<v-btn
							outlined
							color="error"
							:disabled="loading"
							@click="dialog.value = false">
							{{ $t('close') }}
						</v-btn>
					</v-card-actions>
				</form>
			</v-card>
		</template>
	</v-dialog>
</template>

<script>
export default {
	name: 'VDeleteDialog',
	props: {
		value: { type: Boolean, default: false },
		module: { type: String, required: true },
		parameters: { default: null },
	},

	data() {
		return {
			loading: false,
		};
	},

	methods: {
		deleteData() {
			console.log(this.parameters)
			this.loading = true;

			this.$store
				.dispatch(this.module, this.parameters)
				.then(() => {
					this.$eventBus.$emit('show-snackbar', this.$T('messages.delete-done'), {
						done: true,
					});
					this.$emit('on-delete');
					this.$refs.dialog.isActive = false;
				})
				.catch(() => {
					this.$eventBus.$emit('show-snackbar', this.$T('messages.delete-fail'), { error: true });
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},

	computed: {
		localValue: {
			get: function () {
				return this.value;
			},
			set: function (newValue) {
				this.$emit('input', newValue);
			},
		},
	},
};
</script>

<style></style>
